module.exports = __webpack_public_path__ + "media/images/lb/726-fca9d33fc239e1e14bc543ac9bb9c0a0.svg";